import { FormGroup, H5 } from '@blueprintjs/core';
import * as React from 'react';
import { usePortalFeatures } from 'vet-bones/utils/portal';

import { ClassSelector } from 'src/components/ClassSelector';
import { ResourceSelector } from 'src/components/ResourceSelector';
import { useProjectResourceSuggestionsData } from 'src/containers/ProjectResourceSuggestionsDialog/projectResourceSuggestionsData';
import { projectSelector } from 'src/selectors/project';
import { projectClassItemsSelector } from 'src/selectors/projectClassItems';
import * as copy from 'src/templates/copy';
import { useIsVoiceboxEnabled } from 'src/utils/hooks/useIsVoiceboxEnabled';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export type ProjectResourceSelectionPanelProps = {
  disabled?: boolean;
};

export const ProjectResourceSelectionPanel: React.VFC<
  ProjectResourceSelectionPanelProps
> = ({ disabled = false }) => {
  const { projectId } = useRouterParams();
  const {
    selectedClasses,
    selectedResources,
    setSelectedClasses,
    setSelectedResources,
  } = useProjectResourceSuggestionsData();
  const classItems = useReduxSelector(projectClassItemsSelector(projectId));

  const portalFeatures = usePortalFeatures();
  const project = useReduxSelector(projectSelector(projectId));
  const useVoiceboxSuggestions =
    Boolean(useIsVoiceboxEnabled() && portalFeatures.voiceboxSuggestions) &&
    !project?.disableVoiceboxSuggestions;

  return (
    <>
      <FormGroup
        label={
          <H5>
            {copy.components.resourceSuggestionsDialog.selection.resourcesLabel}
          </H5>
        }
        subLabel={
          useVoiceboxSuggestions
            ? copy.components.resourceSuggestionsDialog.selection
                .resourcesHelperTextVoicebox
            : undefined
        }
      >
        <ResourceSelector
          disabled={disabled}
          selected={selectedResources}
          setSelected={setSelectedResources}
        />
      </FormGroup>
      {classItems.length ? (
        <FormGroup
          label={
            <H5>
              {copy.components.resourceSuggestionsDialog.selection.classesLabel}
            </H5>
          }
          subLabel={
            useVoiceboxSuggestions
              ? copy.components.resourceSuggestionsDialog.selection
                  .classesHelperTextVoicebox
              : undefined
          }
        >
          <ClassSelector
            disabled={disabled}
            selected={selectedClasses}
            setSelected={setSelectedClasses}
          />
        </FormGroup>
      ) : null}
    </>
  );
};
